export const siteConfig = {
  brandName: "Toudcompass",
  logo: { type: "wordmark", text: "Toudcompass" },
  description:
    "Independent denim and workwear built from honest materials for years of wear.",
  contact: {
    email: "service@toudcompass.online",
    phone: "+1 415 555 0149",
    address: "San Francisco, California, USA",
  },
  currency: "USD",
  currencySymbol: "$",
  freeShippingThreshold: 150,
  shippingFlatRate: 12,
  social: {
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
  },
};

const denimSizes = [
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "38",
  "40",
  "42",
];
const alphaSizes = ["XS", "S", "M", "L", "XL", "XXL"];

const productData = [
  {
    id: 1,
    name: "Ankara - Straight Leg Selvedge Jeans - 14.75 oz.",
    category: "Jeans",
    price: 275,
    rating: 5,
    reviews: 37,
    image: "/img/products/p01-ankara.jpg",
    images: ["/img/products/p01-ankara.jpg"],
    sizes: denimSizes,
    colors: ["Raw Indigo"],
    material: "14.75 oz. Japanese selvedge denim",
    description:
      "A mid-rise straight fit with room through the seat and thigh, cut from substantial raw indigo denim that softens and records the way you live in it.",
    details: [
      "Button fly",
      "Reinforced pocket bags",
      "Chain-stitched hem",
      "Sanforized fabric",
    ],
    attributes: {
      Fit: "Mid-rise straight",
      Fabric: "100% cotton",
      Weight: "14.75 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "raw denim", "straight leg", "featured"],
    badge: "Best Seller",
    featured: true,
    newArrival: true,
    stock: 18,
  },
  {
    id: 2,
    name: "Sheffield - Straight Tapered Selvedge Jeans - 12.5 oz.",
    category: "Jeans",
    price: 275,
    rating: 4.9,
    reviews: 29,
    image: "/img/products/p02-sheffield.jpg",
    images: ["/img/products/p02-sheffield.jpg"],
    sizes: denimSizes,
    colors: ["Dry Indigo"],
    material: "12.5 oz. Japanese selvedge denim",
    description:
      "An easy straight top block that narrows cleanly below the knee, made in a year-round raw denim with a crisp hand and quick break-in.",
    details: [
      "Button fly",
      "Tapered lower leg",
      "Copper-tone hardware",
      "Sanforized fabric",
    ],
    attributes: {
      Fit: "Straight tapered",
      Fabric: "100% cotton",
      Weight: "12.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "raw denim", "tapered", "new arrival"],
    badge: "New",
    featured: true,
    newArrival: true,
    stock: 22,
  },
  {
    id: 3,
    name: "John Graham Mellor - Slim Straight Selvedge Jeans - 16.5 oz.",
    category: "Jeans",
    price: 275,
    rating: 4.9,
    reviews: 42,
    image: "/img/products/p03-jgm.jpg",
    images: ["/img/products/p03-jgm.jpg"],
    sizes: denimSizes,
    colors: ["Deep Indigo"],
    material: "16.5 oz. Japanese selvedge denim",
    description:
      "A dense, slim-straight jean for committed denim wearers. The clean line is balanced with enough thigh room for everyday movement.",
    details: [
      "Heavyweight construction",
      "Button fly",
      "Lined rear pockets",
      "36-inch inseam",
    ],
    attributes: {
      Fit: "Slim straight",
      Fabric: "100% cotton",
      Weight: "16.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "heavyweight", "slim straight", "featured"],
    featured: true,
    newArrival: true,
    stock: 13,
  },
  {
    id: 4,
    name: "Ladbroke Grove - Slim Tapered Organic Natural Indigo Jeans - 14.5 oz.",
    category: "Jeans",
    price: 285,
    rating: 4.8,
    reviews: 18,
    image: "/img/products/p04-ladbroke.jpg",
    images: ["/img/products/p04-ladbroke.jpg"],
    sizes: denimSizes,
    colors: ["Natural Indigo"],
    material: "14.5 oz. organic cotton selvedge denim",
    description:
      "A close, modern taper in naturally dyed organic denim. It begins crisp and gradually develops a softer blue with high-contrast wear marks.",
    details: [
      "Organic cotton",
      "Natural indigo dye",
      "Button fly",
      "Narrow leg opening",
    ],
    attributes: {
      Fit: "Slim tapered",
      Fabric: "Organic cotton",
      Weight: "14.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["organic", "selvedge", "natural indigo", "new arrival"],
    badge: "Limited",
    featured: true,
    newArrival: true,
    stock: 9,
  },
  {
    id: 5,
    name: "Elgin - Mid Rise Slim Tapered Selvedge Jeans - 14.75 oz.",
    category: "Jeans",
    price: 275,
    rating: 4.9,
    reviews: 26,
    image: "/img/products/p05-elgin.jpg",
    images: ["/img/products/p05-elgin.jpg"],
    sizes: denimSizes,
    colors: ["Raw Indigo"],
    material: "14.75 oz. Japanese selvedge denim",
    description:
      "A balanced mid-rise silhouette with a slim thigh and precise taper, designed to sit securely without feeling restrictive.",
    details: [
      "Mid rise",
      "Button fly",
      "Slim tapered leg",
      "Durable pocketing",
    ],
    attributes: {
      Fit: "Mid-rise slim taper",
      Fabric: "100% cotton",
      Weight: "14.75 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "mid rise", "slim tapered", "new arrival"],
    badge: "New",
    featured: true,
    newArrival: true,
    stock: 20,
  },
  {
    id: 6,
    name: "The Blubaugh - Mid Rise Slim Straight Selvedge Jeans - 16.5 oz.",
    category: "Jeans",
    price: 275,
    rating: 4.8,
    reviews: 16,
    image: "/img/products/p06-blubaugh.jpg",
    images: ["/img/products/p06-blubaugh.jpg"],
    sizes: denimSizes,
    colors: ["Dark Indigo"],
    material: "16.5 oz. Japanese selvedge denim",
    description:
      "A weighty mid-rise jean with a trim, straight leg. Strong yarn character gives this cloth a distinctive grain as it breaks in.",
    details: [
      "Heavyweight denim",
      "Button fly",
      "Slim straight leg",
      "Reinforced stress points",
    ],
    attributes: {
      Fit: "Mid-rise slim straight",
      Fabric: "100% cotton",
      Weight: "16.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "heavyweight", "mid rise"],
    newArrival: true,
    stock: 11,
  },
  {
    id: 7,
    name: "Fredy - Wide Leg Selvedge Jeans - 12.5 oz.",
    category: "Jeans",
    price: 275,
    rating: 4.7,
    reviews: 14,
    image: "/img/products/p07-fredy.jpg",
    images: ["/img/products/p07-fredy.jpg"],
    sizes: denimSizes,
    colors: ["Rinse Indigo"],
    material: "12.5 oz. Japanese selvedge denim",
    description:
      "A generous wide-leg jean with a clean drape and comfortable rise, built in lighter selvedge denim for movement across seasons.",
    details: ["Wide leg", "Button fly", "Roomy top block", "Sanforized fabric"],
    attributes: {
      Fit: "Wide straight",
      Fabric: "100% cotton",
      Weight: "12.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["selvedge", "wide leg", "lightweight"],
    stock: 15,
  },
  {
    id: 8,
    name: `${siteConfig.brandName} Stock - Straight Leg Fit`,
    category: "Jeans",
    price: 149,
    rating: 4.8,
    reviews: 31,
    image: "/img/products/p08-stock-straight.jpg",
    images: ["/img/products/p08-stock-straight.jpg"],
    sizes: denimSizes,
    colors: ["Washed Indigo"],
    material: "13.5 oz. non-selvedge denim",
    description:
      "A straightforward everyday jean with a classic rise, dependable straight leg and softened denim that feels familiar from day one.",
    details: [
      "Zip fly",
      "Straight leg",
      "Pre-shrunk fabric",
      "Utility-grade pocketing",
    ],
    attributes: {
      Fit: "Classic straight",
      Fabric: "100% cotton",
      Weight: "13.5 oz.",
      Origin: "Cut and sewn in USA",
    },
    tags: ["non-selvedge", "straight leg", "everyday"],
    featured: true,
    stock: 28,
  },
  {
    id: 9,
    name: "Fatigue Pant - British Tan Sateen Original Tapered Leg",
    category: "Pants",
    price: 225,
    rating: 5,
    reviews: 44,
    image: "/img/products/p09-fatigue-tan.jpg",
    images: ["/img/products/p09-fatigue-tan.jpg"],
    sizes: denimSizes,
    colors: ["British Tan"],
    material: "Cotton military sateen",
    description:
      "A field-inspired fatigue pant in tightly woven sateen, with useful patch pockets and a measured taper that works with boots or sneakers.",
    details: [
      "Large front patch pockets",
      "Buttoned rear pockets",
      "Tapered leg",
      "Garment washed",
    ],
    attributes: {
      Fit: "Original tapered",
      Fabric: "Cotton sateen",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["fatigue pant", "sateen", "workwear", "featured"],
    badge: "Best Seller",
    featured: true,
    stock: 24,
  },
  {
    id: 10,
    name: "Fatigue Pant - Olive Sateen Straight Wide Leg",
    category: "Pants",
    price: 240,
    rating: 4.8,
    reviews: 21,
    image: "/img/products/p10-fatigue-olive.jpg",
    images: ["/img/products/p10-fatigue-olive.jpg"],
    sizes: denimSizes,
    colors: ["Field Olive"],
    material: "Cotton military sateen",
    description:
      "An easy wide-leg interpretation of the utility pant, finished in earthy olive sateen with clean, durable pocket construction.",
    details: [
      "Straight wide leg",
      "Utility pockets",
      "Button fly",
      "Garment washed",
    ],
    attributes: {
      Fit: "Straight wide",
      Fabric: "Cotton sateen",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["fatigue pant", "olive", "wide leg"],
    featured: true,
    stock: 17,
  },
  {
    id: 11,
    name: "Work Pant - Hickory Stripe",
    category: "Pants",
    price: 269,
    rating: 4.7,
    reviews: 12,
    image: "/img/products/p11-work-hickory.jpg",
    images: ["/img/products/p11-work-hickory.jpg"],
    sizes: denimSizes,
    colors: ["Indigo Hickory Stripe"],
    material: "Cotton hickory stripe twill",
    description:
      "A true work pant with a subtle railroad stripe, roomy pockets and a sturdy straight cut that becomes softer without losing structure.",
    details: [
      "Hickory stripe twill",
      "Tool pocket",
      "Straight leg",
      "Reinforced seams",
    ],
    attributes: {
      Fit: "Relaxed straight",
      Fabric: "100% cotton",
      Weight: "11 oz.",
      Origin: "Made in USA",
    },
    tags: ["work pant", "hickory stripe", "utility"],
    stock: 12,
  },
  {
    id: 12,
    name: "Easy Pant - Cotton Ripstop (Olive)",
    category: "Pants",
    price: 225,
    rating: 4.8,
    reviews: 19,
    image: "/img/products/p12-easy-olive.jpg",
    images: ["/img/products/p12-easy-olive.jpg"],
    sizes: alphaSizes,
    colors: ["Olive"],
    material: "Cotton ripstop",
    description:
      "A relaxed pull-on pant in compact cotton ripstop, balancing a comfortable elastic waist with a crisp, work-ready silhouette.",
    details: [
      "Elasticated drawcord waist",
      "Ripstop weave",
      "Tapered leg",
      "Deep side pockets",
    ],
    attributes: {
      Fit: "Relaxed tapered",
      Fabric: "Cotton ripstop",
      Weight: "Light",
      Origin: "Made in USA",
    },
    tags: ["easy pant", "ripstop", "olive"],
    stock: 23,
  },
  {
    id: 13,
    name: "Tapered Chino",
    category: "Pants",
    price: 225,
    rating: 4.7,
    reviews: 17,
    image: "/img/products/p13-chino.jpg",
    images: ["/img/products/p13-chino.jpg"],
    sizes: denimSizes,
    colors: ["Cramerton Khaki"],
    material: "Dense cotton twill",
    description:
      "A clean chino with a comfortable rise and controlled taper, sewn from sturdy twill that dresses up while keeping its workwear backbone.",
    details: [
      "Slash front pockets",
      "Welt rear pockets",
      "Zip fly",
      "Garment washed",
    ],
    attributes: {
      Fit: "Regular tapered",
      Fabric: "100% cotton twill",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["chino", "khaki", "tapered"],
    stock: 20,
  },
  {
    id: 14,
    name: "Topper - Denim - 7.5 oz.",
    category: "Tops",
    price: 210,
    rating: 5,
    reviews: 33,
    image: "/img/products/p14-topper-denim.jpg",
    images: ["/img/products/p14-topper-denim.jpg"],
    sizes: alphaSizes,
    colors: ["Dark Indigo"],
    material: "7.5 oz. raw denim",
    description:
      "A versatile denim overshirt with a clean collar, dual chest pockets and enough room for light layering. The lighter cloth fades quickly and comfortably.",
    details: [
      "Two chest pockets",
      "Button front",
      "Locker loop",
      "Chain-stitched construction",
    ],
    attributes: {
      Fit: "Regular",
      Fabric: "100% cotton denim",
      Weight: "7.5 oz.",
      Origin: "Made in USA",
    },
    tags: ["denim shirt", "overshirt", "raw denim", "featured"],
    featured: true,
    stock: 18,
  },
  {
    id: 15,
    name: "Topper Chambray Shirt",
    category: "Tops",
    price: 195,
    rating: 4.9,
    reviews: 28,
    image: "/img/products/p15-topper-chambray.jpg",
    images: ["/img/products/p15-topper-chambray.jpg"],
    sizes: alphaSizes,
    colors: ["Blue Chambray"],
    material: "Japanese cotton chambray",
    description:
      "A breathable everyday shirt in finely textured chambray, shaped with a practical workwear cut and understated utility details.",
    details: [
      "Two buttoned chest pockets",
      "Pen slot",
      "Button cuffs",
      "Locker loop",
    ],
    attributes: {
      Fit: "Regular",
      Fabric: "100% cotton chambray",
      Weight: "Light",
      Origin: "Made in USA",
    },
    tags: ["chambray", "work shirt", "everyday"],
    stock: 21,
  },
  {
    id: 16,
    name: "Clampdown Chambray Work Shirt",
    category: "Tops",
    price: 195,
    rating: 5,
    reviews: 46,
    image: "/img/products/p16-clampdown.jpg",
    images: ["/img/products/p16-clampdown.jpg"],
    sizes: alphaSizes,
    colors: ["Indigo Chambray"],
    material: "Japanese cotton chambray",
    description:
      "A trim work shirt with a long, clean line and tough triple-needle seams. Fine chambray texture makes it equally useful on its own or under a jacket.",
    details: [
      "Triple-needle seams",
      "Utility chest pockets",
      "Button cuffs",
      "Curved hem",
    ],
    attributes: {
      Fit: "Trim",
      Fabric: "100% cotton chambray",
      Weight: "Light",
      Origin: "Made in USA",
    },
    tags: ["chambray", "work shirt", "featured"],
    featured: true,
    stock: 16,
  },
  {
    id: 17,
    name: "Denim Jacket - Selvedge Denim - 16.5 oz. with Blanket Lining",
    category: "Jackets",
    price: 390,
    rating: 4.9,
    reviews: 22,
    image: "/img/products/p17-lined-jacket.jpg",
    images: ["/img/products/p17-lined-jacket.jpg"],
    sizes: alphaSizes,
    colors: ["Raw Indigo"],
    material: "16.5 oz. selvedge denim with wool-blend blanket lining",
    description:
      "A cold-weather denim jacket pairing heavyweight raw cloth with a warm striped blanket lining and practical interior storage.",
    details: [
      "Blanket lined body",
      "Selvedge denim",
      "Adjustable waist tabs",
      "Interior pocket",
    ],
    attributes: {
      Fit: "Regular",
      Fabric: "Cotton denim / wool-blend lining",
      Weight: "Heavy",
      Origin: "Made in USA",
    },
    tags: ["denim jacket", "blanket lined", "cold weather"],
    badge: "Cold Weather",
    stock: 8,
  },
  {
    id: 18,
    name: "Paul Herringbone Twill Jacket - Olive",
    category: "Jackets",
    price: 298,
    rating: 4.9,
    reviews: 15,
    image: "/img/products/p18-paul-jacket.jpg",
    images: ["/img/products/p18-paul-jacket.jpg"],
    sizes: alphaSizes,
    colors: ["Olive Herringbone"],
    material: "Cotton herringbone twill",
    description:
      "A compact utility jacket cut from textured herringbone twill, with generous patch pockets and an unstructured shape made for layering.",
    details: [
      "Three patch pockets",
      "Herringbone twill",
      "Button front",
      "Interior pocket",
    ],
    attributes: {
      Fit: "Regular",
      Fabric: "100% cotton",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["utility jacket", "herringbone", "olive", "featured"],
    featured: true,
    stock: 10,
  },
  {
    id: 19,
    name: "Coverall Jacket - Garment Dyed International Orange",
    category: "Jackets",
    price: 225,
    rating: 4.8,
    reviews: 13,
    image: "/img/products/p19-coverall-orange.jpg",
    images: ["/img/products/p19-coverall-orange.jpg"],
    sizes: alphaSizes,
    colors: ["International Orange"],
    material: "Garment-dyed cotton canvas",
    description:
      "A vivid but grounded coverall jacket with a lived-in garment dye, four practical pockets and a relaxed layer-friendly body.",
    details: [
      "Four front pockets",
      "Garment dyed",
      "Button front",
      "Unlined construction",
    ],
    attributes: {
      Fit: "Relaxed",
      Fabric: "100% cotton canvas",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["coverall", "garment dyed", "orange", "new arrival"],
    badge: "New",
    newArrival: true,
    stock: 14,
  },
  {
    id: 20,
    name: "Pocket Tee International Orange",
    category: "Tops",
    price: 38,
    rating: 4.7,
    reviews: 20,
    image: "/img/products/p20-pocket-tee.jpg",
    images: ["/img/products/p20-pocket-tee.jpg"],
    sizes: alphaSizes,
    colors: ["International Orange"],
    material: "Midweight cotton jersey",
    description:
      "A straightforward pocket tee in durable jersey, cut with a comfortable body and ribbed collar that keeps its shape after repeated wear.",
    details: [
      "Single chest pocket",
      "Ribbed collar",
      "Tubular body",
      "Pre-shrunk",
    ],
    attributes: {
      Fit: "Regular",
      Fabric: "100% cotton jersey",
      Weight: "Midweight",
      Origin: "Made in USA",
    },
    tags: ["t-shirt", "pocket tee", "orange"],
    stock: 35,
  },
  {
    id: 21,
    name: "Watch Cap - Cotton (Black)",
    category: "Accessories",
    price: 40,
    rating: 5,
    reviews: 12,
    image: "/img/products/p21-watch-cap.jpg",
    images: ["/img/products/p21-watch-cap.jpg"],
    sizes: ["One Size"],
    colors: ["Black"],
    material: "Dense ribbed cotton knit",
    description:
      "A substantial cotton watch cap with a deep rib and adjustable cuff, built to hold its shape while relaxing naturally with wear.",
    details: [
      "One size",
      "Double-layer knit",
      "Adjustable cuff",
      "Machine washable",
    ],
    attributes: {
      Fit: "One size",
      Fabric: "100% cotton",
      Weight: "Heavy knit",
      Origin: "Made in USA",
    },
    tags: ["watch cap", "cotton", "cold weather"],
    stock: 32,
  },
  {
    id: 22,
    name: `${siteConfig.brandName} X Barnes & Moore Belt`,
    category: "Accessories",
    price: 189,
    rating: 5,
    reviews: 39,
    image: "/img/products/p22-leather-belt.jpg",
    images: ["/img/products/p22-leather-belt.jpg"],
    sizes: ["28", "30", "32", "34", "36", "38", "40", "42"],
    colors: ["Oxblood"],
    material: "Full-grain oak-bark tanned leather",
    description:
      "A wide, hard-wearing leather belt with a hand-cast copper-tone buckle. The dense hide darkens and gains a distinct patina over years.",
    details: [
      "Full-grain leather",
      "Hand-cast buckle",
      "1.5-inch width",
      "Six adjustment holes",
    ],
    attributes: {
      Fit: "Order your jean size",
      Fabric: "Oak-bark tanned leather",
      Weight: "Substantial",
      Origin: "Made in England",
    },
    tags: ["belt", "leather", "heritage"],
    stock: 12,
  },
  {
    id: 23,
    name: "'Roll Your Cuff To Here' Sock Black",
    category: "Accessories",
    price: 10,
    compareAtPrice: 18,
    rating: 4.7,
    reviews: 18,
    image: "/img/products/p23-cuff-sock.jpg",
    images: ["/img/products/p23-cuff-sock.jpg"],
    sizes: ["M", "L"],
    colors: ["Black / Ecru"],
    material: "Cotton-rich rib knit",
    description:
      "A durable ribbed crew sock with a contrasting cuff line, cushioned underfoot for boots and everyday shoes.",
    details: [
      "Ribbed leg",
      "Cushioned footbed",
      "Reinforced heel and toe",
      "Machine washable",
    ],
    attributes: {
      Fit: "Crew",
      Fabric: "Cotton blend",
      Weight: "Medium",
      Origin: "Made in USA",
    },
    tags: ["socks", "sale", "accessories"],
    badge: "Sale",
    stock: 40,
  },
  {
    id: 24,
    name: `2 Arrows Leather / ${siteConfig.brandName} Chain Biker Wallet`,
    category: "Accessories",
    price: 495,
    rating: 4.9,
    reviews: 11,
    image: "/img/products/p24-biker-wallet.jpg",
    images: ["/img/products/p24-biker-wallet.jpg"],
    sizes: ["One Size"],
    colors: ["Natural Tan"],
    material: "Vegetable-tanned leather and solid metal chain",
    description:
      "A compact hand-finished biker wallet with clean card organization and a removable chain, designed to darken and polish with daily use.",
    details: [
      "Vegetable-tanned leather",
      "Removable chain",
      "Card and note sections",
      "Snap closure",
    ],
    attributes: {
      Fit: "One size",
      Fabric: "Full-grain leather",
      Weight: "Substantial",
      Origin: "Hand finished",
    },
    tags: ["wallet", "leather", "limited"],
    badge: "Limited",
    stock: 6,
  },
];

export const productCategories = [
  "All",
  "Jeans",
  "Pants",
  "Tops",
  "Jackets",
  "Accessories",
];

export default productData;
